export default __webpack_public_path__ + "static/media/Biking.675535b6.svg";